<template>
  <div
    class="
      toast-notify
      p-1
      left-4
      gap-1
      bg-easy-grey
      rounded-xl
      border-2 border-easy-grey
      hover:border-yellow
      z-30
    "
    :style="[{ top: `${3 + sessionStore.toastCount * 3}rem` }]"
  >
    <span class="text-sm flex items-center pr-4">
      <ViceGlasses class="w-11 h-11" pathFill="#0F766E" />
      Smart-Glasses have been disconnected
    </span>
    <button @click="closeToast">
      <CrossSimpleIcon type="link" class="text-vice-dark-grey hover:text-strong-grey" />
    </button>
  </div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';
import ViceGlasses from '@/Components/Icons/ViceGlasses.vue';
import CrossSimpleIcon from '@/Components/Icons/CrossSimpleIcon.vue';

export default {
  components: { ViceGlasses, CrossSimpleIcon },
  emits: ['toggleSmartGlassToast'],
  setup(props, { emit }) {
    const sessionStore = useSessionStore();
    const closeToast = () => emit('toggleSmartGlassToast');

    onMounted(() => {
      sessionStore.toastCount += 1;
    });

    onUnmounted(() => {
      sessionStore.toastCount -= 1;
    });

    return { closeToast, sessionStore };
  },
};
</script>
<style scoped />
